import { IMAGES } from "@/lib/site";

export const DEST_PAGES = {
    bangkok: {
        slug: "bangkok",
        city: "Bangkok",
        title: "VIP Tables in Bangkok | BookMyVIP",
        meta: "Book VIP tables and bottle service in Bangkok with the BookMyVIP concierge. Rooftop bars, world-class clubs and premium nightlife — arranged before you arrive.",
        tagline: "Rooftop views. World-class clubs. Non-stop energy.",
        image: IMAGES.bangkok,
        intro: [
            "Bangkok does nightlife at full scale — rooftop bars above Sukhumvit, mega-clubs in RCA, and the lounge-lined sois of Thonglor, all running until late.",
            "The difference between a good night and a great one is rarely luck. It's having the right table, in the right room, already reserved before you land.",
        ],
        arrange: [
            "VIP tables at top nightlife venues",
            "Bottle-service packages where available",
            "Advance club entry coordination",
            "Birthday and celebration setups",
        ],
        areas: ["Sukhumvit", "Thonglor", "RCA", "Silom"],
    },
    phuket: {
        slug: "phuket",
        city: "Phuket",
        title: "VIP Tables in Phuket | BookMyVIP",
        meta: "Book VIP tables and premium nightlife in Phuket with the BookMyVIP concierge. Beach clubs, Bangla Road and luxury nights — arranged before you arrive.",
        tagline: "Beach clubs, luxury nightlife and unforgettable nights.",
        image: IMAGES.phuket,
        intro: [
            "Phuket moves between two moods: barefoot-luxury beach clubs along the west coast, and the full-throttle energy of Bangla Road in Patong.",
            "Tell us which side of the island you want — or both — and we'll line up the table, the bottles and the arrival.",
        ],
        arrange: [
            "VIP tables at beach clubs and nightlife venues",
            "Bottle-service packages where available",
            "Advance entry coordination on busy nights",
            "Group and celebration arrangements",
        ],
        areas: ["Patong", "Bangla Road", "Kamala", "Kata"],
    },
    pattaya: {
        slug: "pattaya",
        city: "Pattaya",
        title: "VIP Tables in Pattaya | BookMyVIP",
        meta: "Book VIP tables and premium nightlife in Pattaya with the BookMyVIP concierge. Walking Street, beachfront clubs and VIP experiences — arranged in advance.",
        tagline: "High-energy nightlife and VIP experiences.",
        image: IMAGES.pattaya,
        intro: [
            "Pattaya is Thailand's loudest night out — the famous Walking Street strip, beachfront clubs and late-night venues built for big groups and big occasions.",
            "It's also a city where having a concierge matters: the right venue, the right table, and no time wasted figuring it out on the night.",
        ],
        arrange: [
            "VIP tables at high-energy nightlife venues",
            "Bottle-service packages where available",
            "Group booking coordination",
            "Bachelor and celebration planning",
        ],
        areas: ["Walking Street", "Beach Road", "Jomtien", "Naklua"],
    },
    "koh-samui": {
        slug: "koh-samui",
        city: "Koh Samui",
        title: "VIP Tables in Koh Samui | BookMyVIP",
        meta: "Book VIP tables and island nightlife in Koh Samui with the BookMyVIP concierge. Chaweng beachfront, beach clubs and luxury island nights — arranged for you.",
        tagline: "Island nights with a luxury twist.",
        image: IMAGES.kohSamui,
        intro: [
            "Koh Samui's nights run on island time — beachfront venues in Chaweng, sunset cocktails near Fisherman's Village, and beach clubs under the palms.",
            "It's the softer, more stylish side of Thai nightlife. We'll make sure your table matches the setting.",
        ],
        arrange: [
            "VIP tables at beach clubs and island venues",
            "Bottle-service packages where available",
            "Sunset-to-late-night itinerary planning",
            "Couple's nights and celebration setups",
        ],
        areas: ["Chaweng", "Bophut", "Fisherman's Village", "Lamai"],
    },
};
